export default __webpack_public_path__ + "static/media/contratar.6aca178c.svg";